import { v4 as uuid } from 'uuid';

import { getChatbotActionButtons } from './getChatbotActionButtons';
import { setChatbotMessageSending } from '../../actions/chatbot/actions';
import { setMessagesFulfilled } from '../../actions/messages';
import { addTextMessageToChat, setDeleteMessage } from '../../actions/sendMessage';
import { CHATBOT_ID } from '../../constants/chatbotId';
import { chatbotSelector } from '../../selectors';
import { chatbotSendMessage } from '../../services/chatbotSendMessage';
import { EChatbotPayload } from '../../services/сhatbot/fetchChatbotActionButtons';
import { showAlert } from '../../slices/alertSlice';
import { TThunkAction } from '../../types/redux/thunk';

export const sendChatbotMessage =
  (message: string, offerId?: number, messageId?: string): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { rowVersion } = chatbotSelector(getState());

    const messageIdFromUuid = uuid();

    dispatch(setChatbotMessageSending(true));

    dispatch(addTextMessageToChat(message, CHATBOT_ID, messageIdFromUuid));

    const chatMessage = await chatbotSendMessage(context, {
      messageText: message,
      offerId,
      messageId,
      rowVersion,
    });

    dispatch(setChatbotMessageSending(false));

    /* istanbul ignore next*/
    if (!chatMessage) {
      dispatch(showAlert({ message: 'Не получилось, попробуйте ещё раз' }));

      return;
    }

    dispatch(
      setDeleteMessage({
        chatId: CHATBOT_ID,
        messageId: messageIdFromUuid,
        messagesMap: context.custom.messagesMap,
      }),
    );

    dispatch(
      setMessagesFulfilled({ messages: [chatMessage], chatId: CHATBOT_ID, messagesMap: context.custom.messagesMap }),
    );
    dispatch(getChatbotActionButtons(EChatbotPayload.SendMessage));
  };
